import { clamp } from '../math-utils';

export default abstract class BaseCurve {
  controls: number[][];

  constructor(controls: number[][]) {
    this.controls = controls || [[0, 0], [1, 1]];
  }

  getValue(t: number): number {
    const { start, end } = this.getNearestControls(t);
    const segmentT = this.toSegmentT(t, start, end);
    return this.evaluate(start, end, segmentT);
  }

  getSlope(t: number): number {
    const { start, end } = this.getNearestControls(t);
    const segmentT = this.toSegmentT(t, start, end);
    return this.evaluateDerivative(start, end, segmentT);
  }

  abstract clone(): BaseCurve

  private getNearestControls(t: number): { start: number[]; end: number[] } {
    const clampedT = clamp(t, 0, 1);
    let controlIndex = this.controls.findIndex(([x]) => x > clampedT);
    if (controlIndex === -1) {
      controlIndex = this.controls.length - 1;
    }
    const start = this.controls[controlIndex - 1];
    const end = this.controls[controlIndex];
    return { start, end };
  }

  // eslint-disable-next-line class-methods-use-this
  private toSegmentT(t: number, startControl: number[], endControl: number[]): number {
    return (t - startControl[0]) / (endControl[0] - startControl[0]);
  }

  abstract evaluate(start: number[], end: number[], t: number): number;

  abstract evaluateDerivative(start: number[], end: number[], t: number): number;
}
